export const EMAIL_PATTERN = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
export const USERNAME_PATTERN = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/g
